<script setup lang="ts">
import type { TabListProps } from "./tab.types";
import { useTabList } from "./useTabList";

const props = defineProps<TabListProps>();

const { classes } = useTabList({ props });
</script>

<template>
  <div part="base" :class="classes" class="e-tab-list" role="tablist">
    <slot />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
